import { useEffect, useState } from 'react';
import './BackgroundDots.css';

const BackgroundDots = ({
  dotColor = 'rgba(110, 126, 229, 0.18)',
  darkDotColor = 'rgba(255, 255, 255, 0.08)',
  dotSize = 1,
  spacing = 16,
  showFade = true,
  fadeIntensity = 28,
  className = '',
  children,
  ...props
}) => {
  const [currentDotColor, setCurrentDotColor] = useState(dotColor);
  const hasContent = Boolean(children);

  useEffect(() => {
    const prefersDarkMode =
      window.matchMedia &&
      window.matchMedia('(prefers-color-scheme: dark)').matches;
    const isDarkModeActive =
      document.documentElement.classList.contains('dark') || prefersDarkMode;
    setCurrentDotColor(isDarkModeActive ? darkDotColor : dotColor);

    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        if (mutation.attributeName === 'class') {
          const updatedIsDarkModeActive =
            document.documentElement.classList.contains('dark');
          setCurrentDotColor(
            updatedIsDarkModeActive ? darkDotColor : dotColor
          );
        }
      });
    });

    observer.observe(document.documentElement, { attributes: true });

    return () => {
      observer.disconnect();
    };
  }, [dotColor, darkDotColor]);

  return (
    <div className={`background-dots ${hasContent ? 'has-content' : ''} ${className}`} {...props}>
      <div
        className="background-dots__pattern"
        style={{
          backgroundSize: `${spacing}px ${spacing}px`,
          backgroundImage: `radial-gradient(${currentDotColor} ${dotSize}px, transparent ${dotSize}px)`
        }}
      />

      {showFade && (
        <div
          className="background-dots__fade"
          style={{
            maskImage: `radial-gradient(ellipse at center, transparent ${fadeIntensity}%, black)`,
            WebkitMaskImage: `radial-gradient(ellipse at center, transparent ${fadeIntensity}%, black)`
          }}
        />
      )}

      <div className="background-dots__vignette" />

      {children && <div className="background-dots__content">{children}</div>}
    </div>
  );
};

export default BackgroundDots;
